/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import './Breadcrumb.scss';
import { AiOutlineHome } from 'react-icons/ai';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { IoIosArrowForward } from 'react-icons/io';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { kclRootState } from "../../../store/gloveSelectorStore";
import { setFilterFacets } from "../../../store/actions";
const Breadcrumb = () => {
    const { PAGE_NAVIGATION } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const locationPathName = location.pathname;
    const navigateToHomePage = () => {
        setFilterFacets([]);
        navigate(PAGE_NAVIGATION.HOME);
    };
    const breadcrumbLocation = useMemo(() => {
        switch(location.pathname) {
            case "/gloves-selector": return `${t("kclGloves.Select_Gloves")}`;
            case "/info-area": return `${t("kclGloves.Info_Area")}`;
            case "/admin-dashboard": return `${t("kclGloves.Admin_Dashboard")}`;
            case "/chemical-search": return `${t("kclGloves.Select_Chemicals")}`;
            default: return '';
        }
    }, [locationPathName]);

    return (
        <div className='gloves-breadcrumb mt-3'>
            <AiOutlineHome onClick={navigateToHomePage} className='home-icon' />
            <IoIosArrowForward className='right-arrow' />
            <div className='nav-item'>
                {locationPathName === "/chemical-results" ? 
                <Link to="/chemical-search" className='bread-selected'>{t("kclGloves.Select_Chemicals")}</Link>
                    : 
                    <>{breadcrumbLocation}</>
                    }
                {locationPathName === "/chemical-results" && <><IoIosArrowForward className='right-arrow arrow-margin' /> {t("kclGloves.Gloves")}</>}
            </div>
        </div>
    );
};

export default Breadcrumb;
